import {HttpStatusCodes} from '../../util/uiconstants';
import {normalize} from '../../util/utils';
import initialstate from '../initialstate';

import {
	GET_CHILD_IT_APPLICATIONS,
	GET_TECHNOLOGIES,
	GET_ALL_TECHNOLOGIES,
	GET_TECHNOLOGIES_UNCATEGORIZED_COUNT,
	GET_IT_RISK_FACTORS,
	GET_IT_APPLICATION_ATTRIBUTES,
	POST_IT_APPLICATIONS_CATALOG,
	RELATE_SUPPORTING_IT,
	UNRELATE_SUPPORTING_IT,
	REJECT_RISK_FACTOR,
	ACCEPT_RISK_FACTOR,
	UPDATE_IT_RISK,
	GET_RELATED_IT_PROCESSES,
	RELATE_IT_PROCESS,
	RELATE_IT_ATTRIBUTE,
	UNRELATE_IT_PROCESS,
	GET_RELATED_CONTROLS_CHART,
	ADD_APPROVAL,
	DELETE_APPROVAL,
	GET_TECHNOLOGY_DETAILS,
	GET_TECHNOLOGY_RISKS,
	CLEAR_TECHNOLOGY_DETAILS,
	GET_FORM_ACTIONS_FOR_TECHNOLOGY,
	GET_FORM_ACTIONS_FOR_TECNOLOGY_DETAILS,
	UPDATE_DOCUMENT,
	POST_RNH_NEW_NOTE,
	UPDATE_RNH_NOTE_DETAIL,
	GET_IT_PLANNING_DASHBOARD_METRICS,
	GET_TECHNOLOGIES_FOR_FILTER_DROPDOWN,
	RESET_TECHNOLOGIES_FOR_FILTER_DROPDOWN,
	REFRESH_RELATED_DOCUMENT_SIGNOFF_REQUIREMENTS_FOR_TECHNOLOGY,
	CLEAR_IT_PLANNING_DASHBOARD_METRICS,
	CLEAR_FORM_ACTIONS_FOR_TECHNOLOGY,
	GET_FORM_ACTIONS_FOR_RELATED_IT_PROCESSES,
	DELETE_DOCUMENT_BY_ID
} from '../../actions/actiontypes';

import normalizeUncategorizedCount from './normalizers/normalizeUncategorizedCount';
import normalizeTechnologies from './normalizers/normalizeTechnologies';
import normalizeTechnology from './normalizers/normalizeTechnology';
import normalizeChildITApplications from './normalizers/normalizeChildITApplications';
import normalizeRiskFactors from './normalizers/normalizeRiskFactors';
import normalizeITAttributes from './normalizers/normalizeITAttributes';
import normalizeITAppToSupportingITApp from './normalizers/normalizeITAppToSupportingITApp';
import normalizeAcceptRiskFactor from './normalizers/normalizeAcceptRiskFactor';
import normalizeRejectRiskFactor from './normalizers/normalizeRejectRiskFactor';
import normalizeItRiskStatus from './normalizers/normalizeItRiskStatus';
import normalizeRelatedITProcesses, {mapSupportingProcesses} from './normalizers/normalizeRelatedITProcesses';
import normalizeRelateUnrelateFlow from './normalizers/normalizeRelateUnrelateFlow';
import normalizeRelatedControlsChart from './normalizers/normalizeRelatedControlsChart';
import normalizeTechnologyDocumentSignoffs from './normalizers/normalizeTechnologyDocumentSignoffs';
import normalizeITApplicationMetrics from './normalizers/normalizeITApplicationMetrics';
import normalizeUpdateOfTechDocuments from './normalizers/normalizeUpdateOfTechDocuments';
import normalizeTechnologiesDocumentNotes from './normalizers/normalizeTechnologiesDocumentNotes';
import normalizeRelatedDocumentSignoffRequirements from './normalizers/normalizeRelatedDocumentSignoffRequirements';

export default (state = initialstate.itPlanning, action) => {
	switch (action.type) {
		case GET_TECHNOLOGIES: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					technologies: normalizeTechnologies(action?.response)
				};
			}
			return state;
		}

		case GET_ALL_TECHNOLOGIES: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				// without pagination - to be used for generating accurate metrics count
				return {
					...state,
					allTechnologies: action?.response?.data
				};
			}
			return state;
		}

		case GET_TECHNOLOGIES_UNCATEGORIZED_COUNT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					uncategorizedCount: normalizeUncategorizedCount(action?.response)
				};
			}
			return state;
		}

		case GET_TECHNOLOGIES_FOR_FILTER_DROPDOWN: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					itApplicationsForDropdownFilter: normalizeTechnologies(action?.response)
				};
			}
			return state;
		}

		case POST_IT_APPLICATIONS_CATALOG: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					itApplicationsCatalog: normalizeTechnologies(action?.response)
				};
			}
			return state;
		}

		case RESET_TECHNOLOGIES_FOR_FILTER_DROPDOWN: {
			return {
				...state,
				itApplicationsForDropdownFilter: null
			};
		}

		case GET_IT_APPLICATION_ATTRIBUTES: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					itAttributes: normalizeITAttributes(action?.response)
				};
			}
			return state;
		}

		case GET_TECHNOLOGY_DETAILS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					technologyDetails: normalizeTechnology(action?.response)
				};
			}
			return state;
		}

		case GET_TECHNOLOGY_RISKS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					technologyRisks: normalizeTechnology(action?.response)
				};
			}
			return state;
		}

		case CLEAR_TECHNOLOGY_DETAILS: {
			return {
				...state,
				technologyDetails: null
			};
		}

		case GET_RELATED_CONTROLS_CHART: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					relatedControlsChart: normalizeRelatedControlsChart(action?.response)
				};
			}

			return state;
		}

		case GET_CHILD_IT_APPLICATIONS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					relatedITApps: {...normalizeChildITApplications(action?.response)}
				};
			}
			return state;
		}

		case DELETE_DOCUMENT_BY_ID: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					technologies: state?.technologies && {
						...state.technologies,
						data: [
							...state.technologies.data.map((t) => ({
								...t,
								relatedDocuments: t.relatedDocuments.filter((d) => d.id !== action.documentId)
							}))
						]
					}
				};
			}
			return state;
		}

		case RELATE_SUPPORTING_IT: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				return normalizeRelateUnrelateFlow(state, action, 'relatedITApps', 'childITApplications', normalizeITAppToSupportingITApp);
			}
			return state;
		}

		case UNRELATE_SUPPORTING_IT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return normalizeRelateUnrelateFlow(state, action, 'relatedITApps', 'childITApplications', normalizeITAppToSupportingITApp, false);
			}
			return state;
		}

		case RELATE_IT_PROCESS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok)
				return normalizeRelateUnrelateFlow(state, action, 'relatedITProcesses', 'itProcesses', mapSupportingProcesses);

			return state;
		}

		case RELATE_IT_ATTRIBUTE: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const updatedAttribute = action?.response;
				const updatedItAttributes = state.itAttributes?.map((attribute) =>
					attribute.itApplicationAttributeId === updatedAttribute.itApplicationAttributeId
						? {...attribute, isSelected: updatedAttribute.isSelected, itRisks: updatedAttribute.itRisks}
						: attribute
				);

				const response = {
					data: [{itApplicationAttributes: updatedItAttributes}]
				};

				return {
					...state,
					itAttributes: normalizeITAttributes(response)
				};
			}

			return state;
		}

		case UNRELATE_IT_PROCESS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return normalizeRelateUnrelateFlow(state, action, 'relatedITProcesses', 'itProcesses', mapSupportingProcesses, false);
			}
			return state;
		}

		case GET_IT_RISK_FACTORS: {
			return {
				...state,
				riskFactors: normalizeRiskFactors(action?.response)
			};
		}

		case REJECT_RISK_FACTOR: {
			return {
				...state,
				riskFactors: normalizeRejectRiskFactor(state.riskFactors, action?.payload)
			};
		}

		case ACCEPT_RISK_FACTOR: {
			return {
				...state,
				riskFactors: normalizeAcceptRiskFactor(state.riskFactors, action?.payload)
			};
		}

		case UPDATE_IT_RISK: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					technologyRisks: normalizeItRiskStatus(state.technologyRisks, action?.response)
				};
			}
			return state;
		}

		case GET_RELATED_IT_PROCESSES: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					relatedITProcesses: normalizeRelatedITProcesses(action?.response)
				};
			}
			return state;
		}

		case ADD_APPROVAL:
		case DELETE_APPROVAL: {
			if ([HttpStatusCodes.Ok, HttpStatusCodes.NoContent].includes(action?.responseObj?.status)) {
				return {
					...state,
					technologies: normalizeTechnologyDocumentSignoffs(state.technologies, action)
				};
			}
			return state;
		}

		case GET_FORM_ACTIONS_FOR_TECHNOLOGY:
		case GET_FORM_ACTIONS_FOR_TECNOLOGY_DETAILS:
		case GET_FORM_ACTIONS_FOR_RELATED_IT_PROCESSES: {
			if (action.response && !action.error) {
				let newState = {...(state?.formActions ?? {})};

				// Available actions:
				newState.availableActions = action?.response?.availableActions;

				// Selected actions:
				newState.selectedActions = normalize(action?.response?.selectedActions, undefined, undefined);

				// Related risks: cant normalize cuz no id field
				newState.risks = action?.response?.risks;

				newState.summaryResponses = normalize(action?.response?.summaryResponses, 'smartEvidenceSourceId');

				// Documents:
				let responseDocuments = [];
				for (const doc of action?.response?.documents ?? []) {
					const document = {
						...doc,
						selectedActions: action?.response?.selectedActions?.filter((a) => a.documentId === doc.id)?.map((a) => a.id)
					};

					responseDocuments.push(document);
				}

				newState.documents = normalize(responseDocuments, undefined, undefined);

				newState.raw = action?.response;

				let chunkName = 'formActions';
				if (action?.type === GET_FORM_ACTIONS_FOR_TECNOLOGY_DETAILS) chunkName = 'technologyDetailsFormActions';
				if (action?.type === GET_FORM_ACTIONS_FOR_RELATED_IT_PROCESSES) chunkName = 'relatedITProcessesFormActions';

				return {
					...state,
					[chunkName]: newState
				};
			}
			return state;
		}
		case CLEAR_FORM_ACTIONS_FOR_TECHNOLOGY: {
			return {
				...state,
				formActions: null
			};
		}
		case GET_IT_PLANNING_DASHBOARD_METRICS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					itApplicationMetrics: normalizeITApplicationMetrics(action?.response)
				};
			}
			return state;
		}
		case CLEAR_IT_PLANNING_DASHBOARD_METRICS: {
			return {
				...state,
				itApplicationMetrics: null
			};
		}
		case UPDATE_DOCUMENT:
		case POST_RNH_NEW_NOTE:
		case UPDATE_RNH_NOTE_DETAIL: {
			if ([HttpStatusCodes.Ok, HttpStatusCodes.Created].includes(action?.responseObj?.status)) {
				return {
					...state,
					technologyDetails: normalizeUpdateOfTechDocuments(
						state.technologyDetails,
						action?.documentId,
						action?.meta?.api?.data ?? {},
						action?.type,
						action.previousStatusId
					),
					technologies: normalizeTechnologiesDocumentNotes(
						state.technologies,
						action?.meta?.api?.data?.documentId,
						action?.meta?.api?.data,
						action.type,
						action.previousStatusId
					)
				};
			}
			return state;
		}
		case REFRESH_RELATED_DOCUMENT_SIGNOFF_REQUIREMENTS_FOR_TECHNOLOGY: {
			return {
				...state,
				technologies: normalizeRelatedDocumentSignoffRequirements(state.technologies, action)
			};
		}

		default:
			return state;
	}
};
